/** Íconos del diseño: SVG inline 16×16, stroke 1.5, currentColor. */
const PATHS: Record<string, string> = {
  queue: "M3 5h10M3 8h10M3 11h6",
  clock: "M8 4v4l2.5 1.5M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z",
  chart: "M3 13V7M8 13V3M13 13v-4",
  gear: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm5.5-2 1-1.2-1-1.7-1.5.4a4.4 4.4 0 0 0-1-.6L10.7 3H8.9l-.3 1.5c-.4.1-.7.3-1 .6L6 4.7l-1 1.7L6 7.6a4 4 0 0 0 0 1.2L5 10l1 1.7 1.5-.4c.3.3.7.5 1 .6l.4 1.6h1.8l.3-1.6c.4-.1.7-.3 1-.6l1.5.4 1-1.7-1-1.2a4 4 0 0 0 0-1.2Z",
  users: "M11 13v-1a2.5 2.5 0 0 0-2.5-2.5h-3A2.5 2.5 0 0 0 3 12v1M7 7.5A2.25 2.25 0 1 0 7 3a2.25 2.25 0 0 0 0 4.5ZM13.5 13v-1a2.5 2.5 0 0 0-1.9-2.4M10.5 3.1a2.25 2.25 0 0 1 0 4.4",
  search: "M11.5 11.5 14 14M7 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
  sun: "M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM8 1.5v1.2M8 13.3v1.2M14.5 8h-1.2M2.7 8H1.5M12.6 3.4l-.8.8M4.2 11.8l-.8.8M12.6 12.6l-.8-.8M4.2 4.2l-.8-.8",
  moon: "M13.5 9.4A5.6 5.6 0 0 1 6.6 2.5 5.6 5.6 0 1 0 13.5 9.4Z",
  logout: "M6 14H3.5A1.5 1.5 0 0 1 2 12.5v-9A1.5 1.5 0 0 1 3.5 2H6M10.5 11 14 8l-3.5-3M14 8H6",
  panel: "M2.5 3.5h11v9h-11zM6.5 3.5v9",
  back: "M10 12.5 5.5 8 10 3.5",
  calendar: "M2.5 4.5h11v9h-11zM2.5 7h11M5.5 2.5v3M10.5 2.5v3",
  chevron: "M4 6.5 8 10.5 12 6.5",
  check: "M3.5 8.5 6.5 11.5 12.5 4.5",
  rotate: "M13 8a5 5 0 1 1-1.6-3.7M13 2v3h-3",
};

export function Icon({ name }: { name: keyof typeof PATHS | string }) {
  return (
    <svg
      width="16" height="16" viewBox="0 0 16 16" fill="none"
      stroke="currentColor" strokeWidth="1.5"
      strokeLinecap="round" strokeLinejoin="round"
      style={{ flexShrink: 0 }} aria-hidden="true"
    >
      <path d={PATHS[name] ?? PATHS.queue} />
    </svg>
  );
}
